import React, { useState, useEffect, useRef } from 'react'

import cx from 'classnames'
import { InputGroup, Form, Button } from 'react-bootstrap'
import { SeekContext } from '../../core/context'

import { getColorsConfig } from '../../../../components/AssetViewer/helper/cssHelper'
import { injectAktivFallback } from '../../../widgets/widget.helper'

import styles from './searchBox.module.scss'
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import map from 'lodash/map';
import pick from 'lodash/pick';
import size from 'lodash/size';


const SearchBoxComponent = ({ className, widgetProps, value, onChange, onSubmit, breakpoint, newChat=false, disabled=true, handleSuggestionClick, getChatHistory }) => {
  const seekContext = React.useContext(SeekContext);
  const [searchBoxStyles, setSearchBoxStyles] = useState({
    fontStyles: {},
    inputFieldStyle: {},
    placeHolderStyle: {},
    promptStyle: {}
  })

  const id = get(widgetProps, 'uid')
  const widgetProperties = get(widgetProps, 'properties')
  const seekBarProps = get(
    widgetProperties,
    `${breakpoint}.questionDesign.bar`,
    {}
  )
  const seekResponseProps = get(
    widgetProperties,
    `${breakpoint}.responseDesign`,
    {}
  )

  const responseStyle = get(seekResponseProps, `type`, 'inline');
  const accentColor = get(seekResponseProps, 'accentColor', {r: 245, g: 245, b: 245, a: 1});
  const session =  get(seekContext, `seekSession.${id}.item`);
  const loading =  get(seekContext, `seekSession.${id}.loading`, false);
  const querying = (get(session, 'chats') || []).find(chat => chat.querying) != null;

  const placeHolder = get(
    seekBarProps,
    'placeholderQuestion',
    'Enter your question here'
  )
  const promptEnabled = get(seekBarProps, 'promptEnabled', false)
  const promptQuestions = get(seekBarProps, 'prompts', [])
  const iconEnabled = get(seekBarProps, 'icon.enabled', true)
  const iconContent = get(seekBarProps, "icon.content")?.trim() || "cleverstory-paperflite-logo";
  const iconSize = get(seekBarProps, `icon.fontSize`, 8)
  const promptAlignment = get(seekBarProps, `promptStyle.alignment`, "center")
  const iconAlignment = get(seekBarProps, `icon.alignment`, "right")
  const openAi = get(seekBarProps, `openAi`, {})
  const openAiColor = get(openAi, "color", "#bdbdbd")
  const openAiSize = get(openAi, "fontSize", 10)
  const openAiAlignment = get(openAi, "alignment", "right")

  useEffect(() => {
    updateSearchBoxStyles()
  }, [ widgetProperties, breakpoint])

  const updateSearchBoxStyles = () => {
    const inputFieldStyle = getSearchBarStyles(widgetProperties, breakpoint)
    const fontStyles = getFontStyles(widgetProperties, breakpoint)
    const placeHolderStyles = getPlaceholderStyles(widgetProperties, breakpoint)
    const promptStyles = getPromptStyles(widgetProperties, breakpoint);
    setSearchBoxStyles({
      inputFieldStyle: inputFieldStyle,
      fontStyles: fontStyles,
      placeHolderStyle: placeHolderStyles,
      promptStyle: promptStyles
    })
  }

  const wrapperStyles = getStyles(widgetProps, breakpoint, 'bar')

  const handleSubmit =()=>{
    onSubmit(value);
  }

  const handleStartNewChat = () => {
    seekContext.invalidateSeekSession(id);
  }

  var iconStyles = {};
  iconStyles = {
    ...iconStyles,
    fontSize: `${iconSize * 2}px`,
  }

  var promptContainerStyles = {}

  promptContainerStyles = {
    ...promptContainerStyles,
    ...(breakpoint === "mobile"
      ? {
          textAlign:
            promptAlignment === "left"
              ? "left"
              : promptAlignment === "right"
              ? "right"
              : "center",
        }
      : {
          justifyContent:
            promptAlignment === "left"
              ? "flex-start"
              : promptAlignment === "right"
              ? "flex-end"
              : "center",
        }),
  };

  var inputWrapperStyle = {}

  inputWrapperStyle = {
    ...inputWrapperStyle,
    ...(iconAlignment && {
      flexDirection: iconAlignment === "left" ? "row-reverse" : "row",
    }),
    ...(!iconEnabled && {
      width: "100%",
    }),
  };

  var openAiStyling = {}

  openAiStyling = {
    ...openAiStyling,
    ...getColorStyles(openAiColor),
    justifyContent: openAiAlignment === "left" ? "flex-start" : "flex-end",
    fontSize: `${openAiSize}px`,
  };

  const { color, ...restFontStyles } = searchBoxStyles.fontStyles;

  const fontStyles = get(widgetProperties, `${breakpoint}.font`, {});
  const colorRgb = get(fontStyles, `tertiaryColor`, null);
  const tertiaryColor = getColorStyles(colorRgb);

  const inputFontStyles = {
    ...restFontStyles,
    ...tertiaryColor,
    width: `calc(100% - ${iconSize * 2}px - 8px)`
  };

  return (
    <div
      id={`search_input_${id}`}
      style={wrapperStyles}
      className={cx(styles.searchBoxContainer, className)}
    >
      <div className={cx(styles.inputFieldWrapper)}>
        <InputGroup
          style={searchBoxStyles.inputFieldStyle}
          className={styles.InputGroup}
        >
          {iconEnabled && 
            <div className={styles.propellerIcon}>
              <i className={cx(styles.Icon, 'cleverstory-seek-fan')} />
            </div>
          }
          {
            <style>
              {`
                #${`search_input_${id}`} input[data-device=${breakpoint}]::-webkit-input-placeholder {
                  color: ${ get(searchBoxStyles, 'placeHolderStyle.color')};
                }
                #search_input_${id} #seekSearchButton i[data-device="${breakpoint}"]::before {
                  color: ${ get(searchBoxStyles, 'fontStyles.color')};
                }
            `}
            </style>
          }
          <div className={styles.inputFieldsWrapper} style={inputWrapperStyle}>
            <input
              data-device={breakpoint}
              className={styles.searchField}
              style={inputFontStyles}
              value={value}
              placeholder={placeHolder}
              disabled={querying || disabled}
              onChange={(e) => onChange(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                  e.preventDefault()
                  handleSubmit()
                }
              }}
              id='seekSearch'
            />
              <Button
                className={styles.seekButton}
                variant='info'
                id='seekSearchButton'
                onClick={handleSubmit}
              >
                <i data-device={breakpoint} className={cx(styles.Icon, iconContent)} style={iconStyles}/>
              </Button>
            </div>
        </InputGroup>
        <span className={styles.label} style={openAiStyling}>Powered by OpenAI</span>
      </div>
      {(promptEnabled && (size(get(session, 'chats')) === 0) && !loading) && (
        <PromptQuestion
          promptQuestions={promptQuestions}
          newChat={newChat}
          disabled={querying || disabled}
          breakpoint={breakpoint}
          responseStyle={responseStyle}
          promptStyles={searchBoxStyles.promptStyle}
          onSelect={handleSuggestionClick}
          promptContainerStyles={promptContainerStyles}
        />
      )}
      { newChat && 
        <div id='newChatButton' className={styles.newChatWrapper}>
          <Button variant='secondary' disabled={querying || disabled} style={getColorStyles(accentColor)} className={styles.newChatButton} onClick={handleStartNewChat}>
            <i style={getColorStyles(accentColor)} className={cx(styles.Icon, 'cleverstory-plus')} />
            New Chat
          </Button>
          {
            <style>
              {`
                #newChatButton i::before {
                  color: ${ getColorsConfig(accentColor)};
                }
              `}
            </style>
          }
        </div>
      }
    </div>
  )
}

const PromptQuestion = ({
  onSelect,
  newChat,
  disabled,
  breakpoint,
  responseStyle,
  promptStyles,
  promptQuestions, 
  promptContainerStyles
}) => {
  const handleSelect = (suggestion) => {
    if(disabled) {
      return;
    }
    onSelect(suggestion)
  }
  return (
    <div
      className={cx(styles.promptsContainer, 
      {[styles.disabled]: disabled},
      {
        [styles.mobileViewPrompts]: (breakpoint === 'mobile' || (newChat && responseStyle === 'slider'))
      })} style={promptContainerStyles}
    >
      {map(promptQuestions, (prompt, index) => {
        if(size(prompt) == 0) {
          return;
        }
        return (
          <div
            key={index}
            style={promptStyles}
            onClick={() => handleSelect(prompt)}
            className={styles.prompt}
          >
            {prompt}
          </div>
        )
      })}
    </div>
  )
}

const searchBoxEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint', 'value', 'onChange', 'onSubmit', 'handleSuggestionClick', 'newChat', 'disabled']
  const next = pick(nextProps, paths)
  const previous = pick(prevProps, paths)

  const equals = isEqual(next, previous)
  return equals
}

export const SeekSearchBox = React.memo(SearchBoxComponent, searchBoxEquals)



function getStyles(widgetProps, breakpoint, type) {

  const deviceProperties = get(widgetProps, `properties.${breakpoint}`)
  const padding = get(deviceProperties, `padding`, 0)
  const border = get(deviceProperties,`seekDesign.border`, {})
  var widgetStyles = {}

  //background
  const backgroundRgb = get(
    deviceProperties,
    `responseDesign.backgroundColor`,
    null
  )

  var background = 'inherit'
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb)
  }

  const borderStyle = getBorderStyles(border);

  widgetStyles = {
    ...widgetStyles,
    ...borderStyle,
  }

  widgetStyles['background'] = background

  if (breakpoint === 'desktop') {
    widgetStyles = {
      ...widgetStyles,
      padding: `${padding}px`,
    }
  }

  if (breakpoint === 'mobile') {
    widgetStyles = {
      ...widgetStyles,
      padding: `${padding}px`,
    }
  }
  return widgetStyles
}

/**
 * --------------------------------------------------
 * Placeholder Styles
 * --------------------------------------------------
 */
export function getPlaceholderStyles(widgetProperties, breakpoint) {
  var styles = {}

  if (!widgetProperties) {
    return styles
  }

  const deviceProperties = get(widgetProperties, `${breakpoint}`)
  const fontStyles = get(deviceProperties, `font`, {})

  //font-color
  const colorRgb = get(fontStyles, `tertiaryColor`, null)
  const color = getColorStyles(colorRgb)
  styles = {
    ...styles,
    ...color
  }

  //font-family
  const fontFamily = get(fontStyles, 'fontFamily')
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: fontFamily
    }
  }

  //font-size
  const fontSizeString = get(fontStyles, 'fontSize', null)
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px'
  }

  styles['fontSize'] = fontSize

  return styles
}

/**
 * 
 * Prompts styles
 */

function getPromptStyles(widgetProperties, breakpoint) {
  var styles = {}

  if (!widgetProperties) {
    return styles
  }

  const deviceProperties = get(widgetProperties, `${breakpoint}`)
  const promptFont = get(deviceProperties, `questionDesign.bar.promptStyle.font`, {})
  const fontStyles = get(deviceProperties, `font`, {})

  //font-color
  const colorRgb = get(fontStyles, `secondaryColor`, { r: 111, g: 111, b: 111, a: 1 })
  const color = getColorStyles(colorRgb)
  styles = {
    ...styles,
    ...color
  }

  //font-family
  const fontFamily = get(promptFont, 'fontFamily', 'Montserrat,sans-serif');
  const fontSize = get(promptFont, 'fontSize', 12);
  const letterSpacing = get(promptFont, 'letterSpacing', 0);
  const lineSpacing = get(promptFont, 'lineSpacing', 1.2);
  const promptStyle = get(promptFont, "style", {});

  styles = {
    ...styles,
    fontFamily: injectAktivFallback(fontFamily),
    ...(fontSize && { fontSize: `${fontSize}px` }),
    ...(letterSpacing && { letterSpacing: `${letterSpacing}px` }),
    ...(lineSpacing && { lineHeight: lineSpacing }),
    ...(promptStyle?.bold && { fontWeight: 'bold' }),
    ...(promptStyle?.italic && { fontStyle: 'italic' }),
    ...(promptStyle?.underline && { textDecoration: 'underline' }),
  }

  return styles
}

/**
 * Generate SearchBar Styles
 *
 */
function getSearchBarStyles(widgetProperties, breakpoint) {
  var styles = {}

  if (!widgetProperties) {
    return styles
  }

  const defaultProperties = get(widgetProperties, `${breakpoint}`)
  const barStyles = get(defaultProperties, `questionDesign.bar`, {})


  //background
  const inputFieldColor = get(barStyles, `inputFieldColor`, {
    r: 255,
    g: 255,
    b: 255,
    a: 1
  })
  var background = 'inherit'
  if (inputFieldColor) {
    background = getColorsConfig(inputFieldColor)
  }

  styles['background'] = background

  //border
  const border = get(barStyles, `border`, {})

  const borderStyle = getBorderStyles(border)
  styles = {
    ...styles,
    ...borderStyle
  }

  return styles
}

export function getColorStyles(value) {
  if (!value) {
    return null
  }

  const colorRgb = value

  var color = 'inherit'
  if (colorRgb) {
    color = getColorsConfig(colorRgb)
  }

  var styles = {
    color: color
  }

  return styles
}

/**
 * Generate Font Styles
 *
 */
function getFontStyles(widgetProperties, breakpoint) {
  var styles = {}

  if (!widgetProperties) {
    return styles
  }

  const deviceProperties = get(widgetProperties, `${breakpoint}`)
  const barStyles = get(deviceProperties, `questionDesign.bar`, {})
  const placeholderAlignment = get(barStyles, `alignment`, "left")
  const iconAlignment = get(barStyles, `icon.alignment`, "right")
  const fontStyles = get(deviceProperties, `font`, {})

  styles = {
    ...styles,
    textAlign: placeholderAlignment === "right" ? "right" : "left",
  };  

  //font-color
  const colorRgb = get(fontStyles, `color`, null)
  const color = getColorStyles(colorRgb)
  styles = {
    ...styles,
    ...color
  }

  //font-family
  const fontFamily = get(fontStyles, 'fontFamily')
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: injectAktivFallback(fontFamily)
    }
  }

  //font-size
  const fontSizeString = get(fontStyles, 'fontSize', "12")
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px'
  }

  styles['fontSize'] = fontSize

  const letterSpacing = get(fontStyles, 'letterSpacing');
  const style = get(fontStyles, 'style') || {};

  styles = {
    ...styles,
    ...(letterSpacing && { letterSpacing: `${Number(letterSpacing)}px` }),
    ...(style?.bold && { fontWeight: 'bold' }),
    ...(style?.italic && { fontStyle: 'italic' }),
    ...(style?.underline && { textDecoration: 'underline' }),
  };

  return styles
}

export function getBorderStyles(border) {
  var styles = {}
  if (!border) {
    return styles
  }

  const topLeft = get(border, 'radius.topLeft', null)
  const topRight = get(border, 'radius.topRight', null)
  const bottomLeft = get(border, 'radius.bottomLeft', null)
  const bottomRight = get(border, 'radius.bottomRight', null)

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px'
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px'
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px'
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px'
  }

  const borderStyle = get(border, 'style', 'bottom');
  if (borderStyle !== 'none') {
    const borderWidthString = get(border, 'width') || 0
    var borderWidget = parseInt(borderWidthString) + 'px'

    styles['borderWidth'] = borderWidget
    styles['borderStyle'] = 'solid'

    const colorRgb = get(border, 'color')
    var color = 'transparent'
    if (colorRgb) {
      color = getColorsConfig(colorRgb)
    }

    styles['borderColor'] = color
  }

  return styles
}
